import { arrayOf, string } from 'prop-types'
import React from 'react'

const HallUses = (props) => {
  if (props.hallUses.length === 0) {
    return null
  }
  return (
    <div className="stats-item hall-uses">
      <div className="heading">Venue uses</div>
      <div className="value">
        <ul>
          {props.hallUses.map(hallUse => (
            <li
              className={`venue-type-icon venue-type-icon-${hallUse.toLowerCase()}`}
              key={hallUse.toLowerCase()}
            >
              {hallUse}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
HallUses.defaultProps = {
  hallUses: [],
}
HallUses.propTypes = {
  hallUses: arrayOf(string),
}

export default HallUses
